import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { CommercialCalculator } from '../Calculators'

import { unitedNumber } from '../propTypes'
import * as info from './info'

import CalculationGroup from '../Widgets/CalculationGroup'

export default class BuildingAndMarketingCost extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(CommercialCalculator).isRequired,
    data: PropTypes.shape({
      baseBuildCost: PropTypes.number,
      developmentContingency: unitedNumber,
      externals: unitedNumber,
      professionalFees: unitedNumber,
      salesAndMarketing: unitedNumber,
      legalFeesPerUnit: PropTypes.number,
      finance: unitedNumber,
    }).isRequired,
    readOnly: PropTypes.bool,
    updateField: PropTypes.func,
  }

  handleFieldChangedFactory = (field) => (value) => this.props.updateField(field, value)

  render() {
    const { calculator, data, readOnly } = this.props

    return (
      <Fragment>
        <h2>Building and Marketing Cost</h2>

        <CalculationGroup
          readOnly={readOnly}
          field='baseBuildCost'
          info={info.baseBuildCost}
          label='Build costs'
          value={data.baseBuildCost}
          onChange={readOnly ? null : this.handleFieldChangedFactory('baseBuildCost')}
          total={calculator.getBaseBuildCostTotal()}
          input={{
            allowZero: true,
            autoFocus: true,
            prefix: '£',
            suffix: calculator.getPerUnitAreaLabel(),
          }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='developmentContingency'
          info={info.developmentContingency}
          label='Development contingency'
          value={data.developmentContingency.value}
          unit={data.developmentContingency.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('developmentContingency')}
          average={calculator.getAverage(calculator.getDevelopmentContingencyTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getDevelopmentContingencyTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='externals'
          info={info.externals}
          label='Externals'
          value={data.externals.value}
          unit={data.externals.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('externals')}
          average={calculator.getAverage(calculator.getExternalsTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getExternalsTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='professionalFees'
          info={info.professionalFees}
          label='Professional fees'
          value={data.professionalFees.value}
          unit={data.professionalFees.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('professionalFees')}
          average={calculator.getAverage(calculator.getProfessionalFeesTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getProfessionalFeesTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='lettingAgentFees'
          info={info.lettingAgentFees}
          label='Letting Agent Fees'
          value={data.lettingAgentFees.value}
          unit={data.lettingAgentFees.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('lettingAgentFees')}
          average={calculator.getAverage(calculator.getLettingAgentFeesTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getLettingAgentFeesTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='legalLettingFees'
          info={info.legalLettingFees}
          label='Legal Letting Fees'
          value={data.legalLettingFees.value}
          unit={data.legalLettingFees.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('legalLettingFees')}
          average={calculator.getAverage(calculator.getLegalLettingFeesTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getLegalLettingFeesTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='salesAgentFees'
          info={info.salesAgentFees}
          label='Sales Agent Fees'
          value={data.salesAgentFees.value}
          unit={data.salesAgentFees.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('salesAgentFees')}
          average={calculator.getAverage(calculator.getSalesAgentFeesTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getSalesAgentFeesTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='legalSalesFees'
          info={info.legalSalesFees}
          label='Legal Sales Fees'
          value={data.legalSalesFees.value}
          unit={data.legalSalesFees.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('legalSalesFees')}
          average={calculator.getAverage(calculator.getLegalSalesFeesTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getLegalSalesFeesTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='finance'
          info={info.finance}
          label='Finance'
          value={data.finance.value}
          unit={data.finance.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('finance')}
          average={calculator.getAverage(calculator.getFinanceTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getFinanceTotal()}
          input={{ allowZero: true }}
        />
      </Fragment>
    )
  }
}
